import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14ac052f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Born In"),
  /*#__PURE__*/_createElementVNode("th", null, "Years Old Today")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h3", null, "This year " + _toDisplayString(_ctx.currentYear), 1),
    _createElementVNode("table", null, [
      _hoisted_1,
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(100, (i) => {
        return _createElementVNode("tr", { key: i }, [
          _createElementVNode("td", null, [
            _createElementVNode("b", null, _toDisplayString(_ctx.currentYear - i), 1)
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("b", null, _toDisplayString(_ctx.currentYear - (_ctx.currentYear - i)), 1),
            _createTextVNode(" Years Old")
          ])
        ])
      }), 64))
    ])
  ], 64))
}